import { Component, Input } from '@angular/core';

@Component({ selector: 'app-html-viewer', templateUrl: './html-viewer.component.html' })
export class HtmlViewerComponent {
  @Input() html: string;
  @Input() sanitize = true;
}
